import { useMutation } from "@tanstack/react-query";
import {
  createSetupIntent,
  CreateSetupIntentRequest,
  createSubscription,
  CreateSubscriptionRequest,
} from "../services/plansService";

export const useCreateSubscription = () => {
  return useMutation({
    mutationFn: async (params: CreateSubscriptionRequest) => {
      try {
        return await createSubscription(params);
      } catch (error: unknown) {
        throw new Error("Failed to create subscription");
      }
    },
    onError: (error: Error) => {
      console.error("Subscription creation error:", error);
    },
    retry: false,
  });
};

export const useCreateSetupIntent = () => {
  return useMutation({
    mutationFn: async (params: CreateSetupIntentRequest) => {
      try {
        return await createSetupIntent(params);
      } catch (error: unknown) {
        throw new Error("Failed to create subscription");
      }
    },
  });
};
